import { Select, SelectProps } from 'antd'
import React from 'react'
import { useCampaignFacebookAccounts } from '../hooks'

export function CampaignFacebookAccountSelect({ campaignId, ...props }: SelectProps & { campaignId: string }) {
    const facebookAccountsQuery = useCampaignFacebookAccounts(campaignId)

    return (
        <Select
            showSearch
            optionFilterProp="label"
            allowClear
            loading={facebookAccountsQuery.isPending}
            options={facebookAccountsQuery.data?.map(({ id, name }) => ({ value: id, label: name }))}
            {...props}
        />
    )
}
